import React, { Children, FC, cloneElement, useState, ReactElement } from 'react';
import cx from 'classnames';
import styles from './InputGroup.module.scss';

export interface InputGroupProps {
  className?: string;
}

const InputGroup: FC<InputGroupProps> = ({ className, children }) => {
  const [focus, setFocus] = useState(false);

  return (
    <div className={cx(className, styles.inputGroup, { [styles.focus]: focus })} onBlur={() => setFocus(false)} onFocus={() => setFocus(true)}>
      {Children.map(children as ReactElement[], (child: ReactElement) =>
        cloneElement(child, {
          className: `${child.props.className} ${styles.child}`,
        })
      )}
    </div>
  );
};

export default InputGroup;
